import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { AccountFacade } from '@corelabs/angular-account';
import { filter, map, tap } from 'rxjs';

export const logout = (): CanActivateFn => {
    return () => {
        const userFacade = inject(UserFacade);
        const accountFacade = inject(AccountFacade);

        accountFacade.logout();

        return accountFacade.loggedOut$.pipe(
            filter((loggedOut) => loggedOut !== null),
            tap(() => userFacade.clear()),
            map(() => true),
        );
    };
};
